"use client";

interface Props {
  blockId: number;
  blockType: string;
  children: React.ReactNode;
}

export default function EditableBlockWrapper({ blockId, blockType, children }: Props) {
  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    window.parent.postMessage(
      { type: "cms_select_block", blockId, blockType },
      "*"
    );
  }

  return (
    <div className="relative group/edit">
      {children}
      {/* Overlay — visible on hover, click sends message to admin parent */}
      <div
        className="absolute inset-0 z-[9999] opacity-0 group-hover/edit:opacity-100 transition-opacity duration-150 cursor-pointer"
        style={{
          background: "rgba(34,113,177,0.08)",
          outline: "2px solid #2271b1",
          outlineOffset: "-2px",
        }}
        onClick={handleClick}
      >
        <span
          className="absolute top-2 left-2 flex items-center gap-1.5 text-white text-xs font-semibold px-2.5 py-1 rounded shadow-md"
          style={{ background: "#2271b1" }}
        >
          ✏️ Nhấn để sửa — {blockType}
        </span>
      </div>
    </div>
  );
}
